var render = function render(_c,_vm){return _c('span',{class:['Icon', _vm.data.class, _vm.data.staticClass]},[_c('i',{class:`i-${_vm.props.name}`}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }